/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface LoginRequest {
  username: string;
  password: string;
  realm: string;
}

export interface LoginResponse {
  accessToken: string;
  refreshToken: string;
  rememberMeToken: string;
}

export interface RefreshRequest {
  refreshToken: string;
}

export interface RefreshResponse {
  accessToken: string;
  refreshToken: string;
}

export interface Payment {
  paymentDate?: string;
  amount?: number;
  refund?: boolean;
}

export interface JourneyDetail {
  arrivalDatetime?: string;
  arrivalStationNumber?: string;
  arrivalStationName?: string;
  departureDatetime?: string;
  departureStationNumber?: string;
  departureStationName?: string;
}

export interface VehicleDetail {
  licensePlateNumber?: number;
  length?: number;
  width?: number;
  height?: number;
}

export interface JourneyObjectV2 {
  salutation?: string;
  birthDate?: string;
  lastName?: string;
  firstName?: string;
  type?: 'ADULT' | 'TEENAGER' | 'ITEM' | 'CHILD' | 'BIKE' | 'DOG' | 'SCHOOLGROUP' | 'CAR' | 'TRAILER' | 'MOTORBIKE' | 'SPECIAL_VEHICLE';
  challenged?: boolean;
  wheelchair?: boolean;
  gender?: 'FEMALE' | 'MALE';
  groupSize?: number;
  attendantCount?: number;
  carDetails?: VehicleDetail;
  motorbikeDetails?: VehicleDetail;
  trailerDetails?: VehicleDetail;
  specialVehicleDetails?: VehicleDetail;
}

export interface JourneyV2 {
  connectionSBs?: JourneyDetail[];
  connectionRBs?: JourneyDetail[];
  objects?: JourneyObjectV2[];
}

export interface ValidityDetail {
  rideBound?: string;
  validityType?: 'commute_relative' | 'commute_absolut' | 'oneway' | 'no_validity';
  validityFrom?: string;
  validityTo?: string;
}

export interface BookingOrder {
  bookingId: string;
  bookingCode: string;
  state: 'ACTIVE' | 'BOOKED' | 'CANCELLED' | 'UNDONE' | 'INVALID' | 'REMOVED';
  isCancelBooking?: boolean;
  productNames: string[];
  journeys?: JourneyV2[];
  tickets?: JourneyV2[];
  validityDetails?: ValidityDetail;
  totalRefundedAmount?: number;
}

export interface GetBookingV2Response {
  state?: 'FROZEN' | 'PAID' | 'SHOPCART' | 'CLEANED' | 'BOOKED';
  userNumber: string;
  email?: string;
  alternativeEmail?: string;
  externalTransactionNumber?: string;
  businessUnitIdCharged?: string;
  invoiceNumber?: string;
  lastChange?: string;
  payments?: Payment[];
  bookingId: string;
  bookingCode: string;
  orders: BookingOrder[];
}

export interface PrebookPaymentInformationV4 {
  amount?: number;
  customerRef?: string;
  paymentMethod: 'INVOICE' | 'EXTERNAL';
  externalTransactionNumber?: string;
  email: string;
  customerNumber?: string;
  personId?: string;
}

export interface Relation {
  lhs: number;
  relationType: 'attendant_of' | 'child_of' | 'belongs_to';
  rhs: number;
}

export interface SectionStop {
  name?: string;
  stationNumber?: number;
  arrival?: string;
  arrivalAccessExitAmendable?: boolean;
  arrivalPlatform?: string;
  departure?: string;
  departureAccessExitAmendable?: boolean;
  departurePlatform?: string;
  gpsCoordinates?: number[];
}

export interface SectionAttribute {
  attributeType: string;
  range?: number[];
  value: object;
  svalue?: string;
  lvalue?: string;
  code?: string;
  priority?: number;
}

export interface SectionGPS {
  latitude?: number;
  longitude?: number;
}

export interface ConnectionSection {
  i?: number;
  arrivalTimestamp?: string;
  departureTimestamp?: string;
  transportType?: string;
  passlist?: SectionStop[];
  attributes?: SectionAttribute[];
  realGraph?: SectionGPS[];
}

export interface ConnectionFilter {
  bikesAllowed?: boolean;
  maxTrainChanges?: number;
  motorailTrainOnly?: boolean;
  departureTimestamp?: string;
  arrivalTimestamp?: string;
  trainChangeTimeExtension?: 'NO_EXTEND' | 'EXTEND_SHORT' | 'EXTEND' | 'EXTEND_LONG' | 'EXTEND_EXTRA_LONG';
  numberOfConnectionsAfter?: number;
  numberOfConnectionsBefore?: number;
  viaStationNumber?: number;
  viaMinStayMinutes?: number;
  wheelchairCapable?: boolean;
}

export interface MultilangText {
  de?: string;
  en?: string;
  it?: string;
  fr?: string;
}

export interface ProductDetailObject {
  index: number;
  objectRefCards?: number[];
  notesClient?: MultilangText;
  priceClass1?: number;
  priceClass2?: number;
  priceNoClass?: number;
}

export interface ProductDetail {
  title: string;
  name: MultilangText;
  notesClient?: MultilangText;
  prodGroupLabels?: string[];
  globallyPriced?: boolean;
  objects: ProductDetailObject[];
  scope?: number[][];
  validityPeriodFrom?: string;
  validityPeriodTo?: string;
  validityType: 'commute_relative' | 'commute_absolut' | 'oneway' | 'no_validity';
  validityCustomText?: MultilangText;
  priceClass1?: number;
  priceClass2?: number;
  priceNoClass?: number;
}

export interface CompartmentObject {
  index?: number;
  reservability?: 'NR' | 'RB' | 'RP' | 'GP';
  globallyPriced?: boolean;
  price?: number;
  objectRefCards?: number[];
}

export interface PrebookCompartmentSpotLocation {
  param?: 'WINDOW_UPPER' | 'MIDDLE' | 'AISLE_LOWER' | 'NECESSARILY_WINDOW_LOWER';
  name?: MultilangText;
  selected?: boolean;
}

export interface PrivateVariationAllocationObject {
  index: number;
  id?: number;
  price?: number;
}

export interface PrivateVariationAllocation {
  objects: PrivateVariationAllocationObject[];
}

export interface PrebookPrivateVariation {
  surchargePrice?: number;
  count: number;
  allocations: PrivateVariationAllocation[];
  selected?: boolean;
}

export interface PrebookReservationCompartmentV3 {
  id: number;
  externalIdentifier: string;
  accommodationClass?: 'class1' | 'class2';
  accommodationType?: 'SE' | 'BE' | 'LE' | 'AR';
  isBusinessClass?: boolean;
  capacity?: number;
  freeFollowupReservationApplied?: boolean;
  name?: MultilangText;
  objects?: CompartmentObject[];
  special?: boolean;
  surchargePrice?: number;
  selected?: boolean;
  spotLocations?: PrebookCompartmentSpotLocation[];
  privateVariations?: PrebookPrivateVariation[];
}

export interface PrebookReservationSegment {
  scope?: number[];
  reservability: 'NR' | 'RB' | 'RP' | 'GP';
  prodGroupLabels?: string[];
  compartments?: PrebookReservationCompartmentV3[];
}

export interface PrebookProductReservation {
  reservationSegments: PrebookReservationSegment[];
  priceClass1?: number;
  priceClass2?: number;
  priceBusinessClass?: number;
  selected?: 'class1' | 'classBusiness' | 'class2';
}

export interface PrebookApiProduct {
  name?: string;
  outputTypes: 'MOBILE' | 'PDF' | 'SECURITY_PAPER';
  partialOffer: boolean;
  productDetails: ProductDetail[];
  productType: 'CITY_TICKET' | 'EXTRA' | 'SHOP' | 'CONNECTION' | 'RESERVATION_ONLY';
  reservationMandatory?: boolean;
  rideBound: boolean;
  singleVariety: boolean;
  validityType: 'commute_relative' | 'commute_absolut' | 'oneway' | 'no_validity';
  partialClass1Scope?: number[][];
  priceBusinessClass?: number;
  priceClass1?: number;
  priceClass1Impure?: boolean;
  priceClass2?: number;
  priceNoClass?: number;
  prodGroupLabels?: string[];
  refCards?: number[];
  partialOfferScope?: number[][];
  validityPeriodFrom?: string;
  validityPeriodTo?: string;
  validityCustomText?: MultilangText;
  selected?: 'class1' | 'class2' | 'classBusiness' | 'noclass';
  reservation?: PrebookProductReservation;
}

export interface PrebookObjectV4 {
  birthDate?: string;
  cards?: number[];
  type: 'person' | 'challenged' | 'wheelchair' | 'dog' | 'bike' | 'item' | 'motorbike' | 'car';

  /**
   * @min 1
   * @max 8
   */
  vehicleCategory?: number;
  vehicleHeight?: number;
  rearRack?: boolean;
  rearRackHeightIncrease?: number;

  /** @max 4 */
  rearRackNumberOfBikes?: number;
  roofRack?: boolean;

  /** possible values 10,15,20,25,30,40,50,60 */
  roofRackHeight?: number;
  textileRoof?: boolean;
  firstName?: string;
  lastName?: string;
  gender?: 'male' | 'female' | 'diverse';
  licensePlateNumber?: string;
  kfzPhoneNumber?: string;
}

export interface InformationMessage {
  category?: number;
  validFrom?: string;
  validTo?: string;
  sectionIndex?: number;
  header?: string;
  text?: string;
  textPlain?: string;
  link?: string;
}

export interface PrebookOrderV4 {
  relations?: Relation[];
  rfpIndex?: number;
  sections?: ConnectionSection[];
  filter?: ConnectionFilter;
  shopProductId?: string;
  shopProductTimestamp?: string;
  offers: PrebookApiProduct[];
  objects: PrebookObjectV4[];
  informationMessages?: InformationMessage[];
}

export interface PrebookV4Request {
  paymentInformation: PrebookPaymentInformationV4;
  orders: PrebookOrderV4[];
}

export interface PrebookV4Response {
  bookingId: string;
  bookingCode: string;
}

export interface AdditionalInfo {
  subPaymentMethod: 'CREDITCARD_WC' | 'EPS_WC' | 'PAYPAL';
  brand: 'visa' | 'mastercard' | 'diners' | 'amex' | 'jcb' | 'eps' | 'paypal';
  provider?: 'Paypal' | 'SIX' | 'PAYPAL_DIRECT';
  transactionId: string;
  approvalCode?: string;
  transactionIdAcquirer?: string;
  merchantId?: string;
}

export interface PaymentInformationV4 {
  amount?: number;
  customerRef?: string;
  paymentMethod: 'INVOICE' | 'EXTERNAL';
  externalTransactionNumber?: string;
  email: string;
  customerNumber?: string;
  additionalInfo?: AdditionalInfo;
}

export interface FinalizeV4Request {
  bookingId: string;
  bookingCode: string;
  paymentInformation: PaymentInformationV4;
}

export interface FinalizeV4Response {
  bookingId?: string;
  bookingCode?: string;
}

export interface I18NText {
  de?: string;
  en?: string;
  fr?: string;
  it?: string;
}

export interface TimeRange {
  begin: string;
  end: string;
}

export interface ProductStationFTO {
  stationNumber: number;
  stationName: string;
}

export interface ShopResponse {
  shopProductId: string;
  displayText?: I18NText;
  dateMandatory?: 'date' | 'date_time' | 'none';
  connectionMandatory?: boolean;
  timeRanges?: TimeRange[];
  timeRangesIncluded?: boolean;
  validTo?: string;
  passengerMandatory?: boolean;
  cardsMandatory?: number[];
  minQuantity?: number;
  maxQuantity?: number;
  fromStations?: ProductStationFTO[];
  toStations?: ProductStationFTO[];
  bike?: boolean;
  motorail?: boolean;
  wheelchair?: boolean;
  trains?: boolean;
  onlyRegionalTraffic?: boolean;
  nonstop?: boolean;
  additionalOffersCityTicket?: boolean;
  additionalOffersExtras?: boolean;
  linkedShopProductId?: string;
}

export interface ConnectionV3Request {
  departureStationNumber: number;
  arrivalStationNumber: number;
  departureTimestamp?: string;
  arrivalTimestamp?: string;
  numberConnectionsAfter?: number;
  numberConnectionsBefore?: number;
  allDay?: boolean;
  langInformationMessage: 'en' | 'de' | 'it';
  viaStationNumber?: number;
  viaMinStayMinutes?: number;
  maxTrainChanges?: number;
  trainChangeTimeExtention?: 'NO_EXTEND' | 'EXTEND_SHORT' | 'EXTEND' | 'EXTEND_LONG' | 'EXTEND_EXTRA_LONG';
  bikesAllowed?: boolean;
  wheelchairCapable?: boolean;
  motorailTrainOnly?: boolean;
}

export interface IOffsetDateTime {
  offset?: object;
  monthValue?: number;
  hour?: number;
  minute?: number;
  second?: number;
  nano?: number;
  year?: number;
  month?: string;
  dayOfMonth?: number;
  dayOfWeek?: string;
  dayOfYear?: number;
}

export interface SectionStopV3 {
  name: string;
  stationNumber: number;
  arrivalAccessExitAmendable: boolean;
  arrivalPlatform: string;
  departureAccessExitAmendable: boolean;
  departurePlatform: string;
  gpsCoordinates: number[];
  stopState: string[];
  arrivalAccessExitAmendableRT: boolean;
  arrivalPlatformRT: string;
  departureAccessExitAmendableRT: boolean;
  departurePlatformRT: string;
  timestampArrival: string;
  timestampDeparture: string;
  timestampArrivalRT: IOffsetDateTime;
  timestampDepartureRT: IOffsetDateTime;
}

export interface ConnectionResponseSectionV3 {
  i: number;
  transportType: string;
  attributes: SectionAttribute[];
  realGraph?: number[][];
  timestampArrival: string;
  timestampDeparture: string;
  passlist: SectionStopV3[];
}

export interface ConnectionResponseV3 {
  id: string;
  rtconinfo: 'NORMAL' | 'HAS_ALTERNATIVE' | 'IS_ALTERNATIVE' | 'FAILURE' | 'CHANGE_NOT_POSSIBLE' | 'BOARDING_NOT_POSSIBLE' | 'ALIGHTING_NOT_POSSIBLE' | 'HAS_ACTUAL_TIME';
  sections: ConnectionResponseSectionV3[];
  informationMessages?: InformationMessage[];
}

export interface ConnectionV3Response {
  connections: ConnectionResponseV3[];
}

export interface ShopProductRequest {
  shopProductId: string;
  shopProductTimestamp?: string;
}

export interface ObjectV6 {
  birthDate?: string;
  cards?: number[];
  type: 'person' | 'challenged' | 'wheelchair' | 'dog' | 'bike' | 'item' | 'motorbike' | 'car';

  /**
   * @min 1
   * @max 8
   */
  vehicleCategory?: number;
  vehicleHeight?: number;
  rearRack?: boolean;
  rearRackHeightIncrease?: number;

  /** @max 4 */
  rearRackNumberOfBikes?: number;
  roofRack?: boolean;

  /** possible values 10,15,20,25,30,40,50,60 */
  roofRackHeight?: number;
  textileRoof?: boolean;
}

export interface OfferV6RequestForProposal {
  connection?: ConnectionV3Request;
  shopProduct?: ShopProductRequest;
  objects: ObjectV6[];
  relations?: Relation[];
}

export interface CombinedOfferV6Request {
  customerNumber?: string;
  rfp?: OfferV6RequestForProposal[];
}

export interface CompartmentSpotLocation {
  param?: 'WINDOW_UPPER' | 'MIDDLE' | 'AISLE_LOWER' | 'NECESSARILY_WINDOW_LOWER';
  name?: MultilangText;
}

export interface PrivateVariation {
  surchargePrice?: number;
  count: number;
  allocations: PrivateVariationAllocation[];
}

export interface ReservationCompartment {
  id: number;
  externalIdentifier: string;
  accommodationClass?: 'class1' | 'class2';
  accommodationType?: 'SE' | 'BE' | 'LE' | 'AR';
  isBusinessClass?: boolean;
  capacity?: number;
  freeFollowupReservationApplied?: boolean;
  name?: MultilangText;
  spotLocations?: CompartmentSpotLocation[];
  objects?: CompartmentObject[];
  special?: boolean;
  surchargePrice?: number;
  privateVariations?: PrivateVariation[];
}

export interface ReservationSegment {
  scope?: number[];
  reservability: 'NR' | 'RB' | 'RP' | 'GP';
  prodGroupLabels?: string[];
  compartments?: ReservationCompartment[];
}

export interface ProductReservation {
  reservationSegments: ReservationSegment[];
  priceClass1?: number;
  priceClass2?: number;
  priceBusinessClass?: number;
}

export interface ApiProduct {
  name?: string;
  outputTypes: 'MOBILE' | 'PDF' | 'SECURITY_PAPER';
  partialOffer: boolean;
  productDetails: ProductDetail[];
  productType: 'CITY_TICKET' | 'EXTRA' | 'SHOP' | 'CONNECTION' | 'RESERVATION_ONLY';
  reservationMandatory?: boolean;
  rideBound: boolean;
  singleVariety: boolean;
  validityType: 'commute_relative' | 'commute_absolut' | 'oneway' | 'no_validity';
  partialClass1Scope?: number[][];
  priceBusinessClass?: number;
  priceClass1?: number;
  priceClass1Impure?: boolean;
  priceClass2?: number;
  priceNoClass?: number;
  prodGroupLabels?: string[];
  refCards?: number[];
  partialOfferScope?: number[][];
  validityPeriodFrom?: string;
  validityPeriodTo?: string;
  validityCustomText?: MultilangText;
  co2Savings?: number;
  reservation?: ProductReservation;
}

export interface ConnectionWithOffersV6 {
  sections: ConnectionSection[];
  offers: ApiProduct[];
  informationMessages?: InformationMessage[];
	warnings?: Array<Warnings>;
}

export interface Warnings {
	title?: string;
	sectionIndex?: number;
	status?: Warnings_Status;
}

export enum Warnings_Status {
	NO_AVAILABILITY = 'noAvailability',
	TEMPORARILY_UNAVAILABLE = 'temporarilyUnavailable',
	INSUFFICIENT_AVAILABILITY = 'insufficientAvailability',
}

export interface ConnectionBasedProposalV6 {
  connections: ConnectionWithOffersV6[];
  filter?: ConnectionFilter;
}

export interface ShopBasedProposal {
  shopProductId: string;
  shopProductTimestamp?: string;
  offers: ApiProduct[];
}

export interface CombinedOfferV6ResponseFTO {
  rfpIndex: number;
  connectionBasedProposal?: ConnectionBasedProposalV6;
  shopBasedProposal?: ShopBasedProposal;
}

export interface CancelV3Request {
  technicalCancel?: boolean;
  returnAmountAccordingTariff: number;
  cancelAmountAccordingTariff: number;
  amount?: number;
  bookingCode: string;
  bookingId: string;

  /** only for ÖBB internal use */
  additionalInfo?: AdditionalInfo;
}

export interface CancelV3Response {
  bookingCode: string;
  bookingId: string;
}

export interface CancelConditionV4Request {
  bookingCode: string;
  bookingId: string;
  technicalCancel?: boolean;
}

export interface CancelInformation {
  cancellationPossible: boolean;
  ticketsCancelled: boolean;
  returnAmountAccordingTariff: number;
  cancelAmountAccordingTariff: number;
}

export interface TicketInformation {
  ticketsAcquired?: 'FULL' | 'PARTLY' | 'NOT';
  acquisitionType?: 'DEP_CODE' | 'SECURITY_PAPER' | 'PDF' | 'MOBILE' | 'NONE' | 'MIXED';
  depositCodeStatus?: 'FETCHED' | 'NOT_FETCHED' | 'CANCELLED' | 'MIXED';
}

export interface ConnectionInformation {
  departureStationNumber?: number;
  arrivalStationNumber?: number;
  departureStationName?: string;
  arrivalStationName?: string;
  departureDatetime?: string;
  arrivalDatetime?: string;
}

export interface CancelCondOrder {
  cancelInformation: CancelInformation;
  ticketInformation?: TicketInformation;
  connection?: ConnectionInformation;
  productNames: string[];
  objects: PrebookObjectV4[];
}

export interface CancelConditionV4Response {
  state: 'FROZEN' | 'PAID' | 'SHOPCART' | 'CLEANED' | 'BOOKED';
  cancellationPossible: 'FULL' | 'PARTLY' | 'NOT';
  technicalCancelPossible?: boolean;
  technicalCancelPossibleUntil?: string;
  amount: number;
  returnAmountAccordingTariff: number;
  cancelAmountAccordingTariff: number;
  ticketsAcquired: 'FULL' | 'PARTLY' | 'NOT';
  bookingCode: string;
  bookingId: string;
  orders: CancelCondOrder[];
}

export interface Address {
  street?: string;
  number?: string;
  addressSupplement?: string;
  zipCode?: string;
  city?: string;
  countryIsoCode?: string;
}

export interface Card {
  cardNumber: string;
  chipId?: string;
  revisionNumber?: number;
  sequenceNumber?: number;
  validFrom: string;
  validTo: string;
  productName: string;
  cardProductCode: string;
  productClass: string;
  productSubClass: string;
  state: 'ACTIVE' | 'LOCKED' | 'EXPIRED' | 'NOT_YET_VALID';
}

export interface CardsV1Response {
  customerNumber: string;
  personId: string;
  gender?: 'W' | 'M';
  title?: string;
  titleSuffix?: string;
  firstName?: string;
  lastName?: string;
  birthDate?: string;
  address?: Address;
  email?: string;
  cards: Card[];
}

export interface CardBlacklist {
  cardNumber: string;
  sequence: number;
  revision: number;
  lockReason: 'CANCELLATION' | 'DAMAGE' | 'DATA_CHANGE' | 'THEFT' | 'PRINTING_ERROR' | 'LOSS' | 'PAYMENT_OUTSTANDING';
  confiscate: boolean;
}

export interface CardsBlacklistResponse {
  cards: CardBlacklist[];
}

export interface AcquiredTicket {
  ticket: string;
  generatedAt: string;
}

export interface AcquireTicketV1Response {
  tickets?: AcquiredTicket[];
  link?: string;
}

export interface TaxCertificateV2Response {
  taxCertificate: string;
  generatedAt: string;
}

export type ReductionCardsV1Request = object;

export interface IReductionCardFTO {
  code: number;
  cardName: I18NText;
  cardShortName: I18NText;
  numberRequired?: boolean;
  isFamily?: boolean;
  isChallenged?: boolean;
  motorailTrainRelevance?: string;
  dateFrom?: string;
  dateTo?: string;
}

export interface ReductionCardsV1Response {
  reductionCards: IReductionCardFTO[];
}

export type GetStationListV1Request = object;

export interface GetStationListV1Response {
  stationNumber: number;
  stationName: string;
  latitude: number;
  longitude: number;
}

export interface ConfigGetV1Request {
  key?: string;
}

export type ConfigGetV1Response = object;

export type QueryParamsType = Record<string | number, any>;
export type ResponseFormat = keyof Omit<Body, 'body' | 'bodyUsed'>;

export interface FullRequestParams extends Omit<RequestInit, 'body'> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseFormat;
  /** request body */
  body?: unknown;
  /** base url */
  baseUrl?: string;
  /** request cancellation token */
  cancelToken?: CancelToken;
}

export type RequestParams = Omit<FullRequestParams, 'body' | 'method' | 'query' | 'path'>;

export interface ApiConfig<SecurityDataType = unknown> {
  baseUrl?: string;
  baseApiParams?: Omit<RequestParams, 'baseUrl' | 'cancelToken' | 'signal'>;
  securityWorker?: (securityData: SecurityDataType | null) => Promise<RequestParams | void> | RequestParams | void;
  customFetch?: typeof fetch;
}

export interface HttpResponse<D extends unknown, E extends unknown = unknown> extends Response {
  data: D;
  error: E;
}

type CancelToken = Symbol | string | number;

export enum ContentType {
  Json = 'application/json',
  FormData = 'multipart/form-data',
  UrlEncoded = 'application/x-www-form-urlencoded',
}

export class HttpClient<SecurityDataType = unknown> {
  public baseUrl: string = '';
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>['securityWorker'];
  private abortControllers = new Map<CancelToken, AbortController>();
  private customFetch = (...fetchParams: Parameters<typeof fetch>) => fetch(...fetchParams);

  private baseApiParams: RequestParams = {
    credentials: 'same-origin',
    headers: {},
    redirect: 'follow',
    referrerPolicy: 'no-referrer',
  };

  constructor(apiConfig: ApiConfig<SecurityDataType> = {}) {
    Object.assign(this, apiConfig);
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  private encodeQueryParam(key: string, value: any) {
    const encodedKey = encodeURIComponent(key);
    return `${encodedKey}=${encodeURIComponent(typeof value === 'number' ? value : `${value}`)}`;
  }

  private addQueryParam(query: QueryParamsType, key: string) {
    return this.encodeQueryParam(key, query[key]);
  }

  private addArrayQueryParam(query: QueryParamsType, key: string) {
    const value = query[key];
    return value.map((v: any) => this.encodeQueryParam(key, v)).join('&');
  }

  protected toQueryString(rawQuery?: QueryParamsType): string {
    const query = rawQuery || {};
    const keys = Object.keys(query).filter(key => 'undefined' !== typeof query[key]);
    return keys.map(key => (Array.isArray(query[key]) ? this.addArrayQueryParam(query, key) : this.addQueryParam(query, key))).join('&');
  }

  protected addQueryParams(rawQuery?: QueryParamsType): string {
    const queryString = this.toQueryString(rawQuery);
    return queryString ? `?${queryString}` : '';
  }

  private contentFormatters: Record<ContentType, (input: any) => any> = {
    [ContentType.Json]: (input: any) => (input !== null && (typeof input === 'object' || typeof input === 'string') ? JSON.stringify(input) : input),
    [ContentType.FormData]: (input: any) =>
      Object.keys(input || {}).reduce((formData, key) => {
        const property = input[key];
        formData.append(key, property instanceof Blob ? property : typeof property === 'object' && property !== null ? JSON.stringify(property) : `${property}`);
        return formData;
      }, new FormData()),
    [ContentType.UrlEncoded]: (input: any) => this.toQueryString(input),
  };

  private mergeRequestParams(params1: RequestParams, params2?: RequestParams): RequestParams {
    return {
      ...this.baseApiParams,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...(this.baseApiParams.headers || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  private createAbortSignal = (cancelToken: CancelToken): AbortSignal | undefined => {
    if (this.abortControllers.has(cancelToken)) {
      const abortController = this.abortControllers.get(cancelToken);
      if (abortController) {
        return abortController.signal;
      }
      return void 0;
    }

    const abortController = new AbortController();
    this.abortControllers.set(cancelToken, abortController);
    return abortController.signal;
  };

  public abortRequest = (cancelToken: CancelToken) => {
    const abortController = this.abortControllers.get(cancelToken);

    if (abortController) {
      abortController.abort();
      this.abortControllers.delete(cancelToken);
    }
  };

  public request = async <T = any, E = any>({ body, secure, path, type, query, format, baseUrl, cancelToken, ...params }: FullRequestParams): Promise<HttpResponse<T, E>> => {
    const secureParams = ((typeof secure === 'boolean' ? secure : this.baseApiParams.secure) && this.securityWorker && (await this.securityWorker(this.securityData))) || {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const queryString = query && this.toQueryString(query);
    const payloadFormatter = this.contentFormatters[type || ContentType.Json];
    const responseFormat = format || requestParams.format;

    return this.customFetch(`${baseUrl || this.baseUrl || ''}${path}${queryString ? `?${queryString}` : ''}`, {
      ...requestParams,
      headers: {
        ...(type && type !== ContentType.FormData ? { 'Content-Type': type } : {}),
        ...(requestParams.headers || {}),
      },
      signal: cancelToken ? this.createAbortSignal(cancelToken) : void 0,
      body: typeof body === 'undefined' || body === null ? null : payloadFormatter(body),
    }).then(async response => {
      const r = response as HttpResponse<T, E>;
      r.data = null as unknown as T;
      r.error = null as unknown as E;

      const data = !responseFormat
        ? r
        : await response[responseFormat]()
            .then(data => {
              if (r.ok) {
                r.data = data;
              } else {
                r.error = data;
              }
              return r;
            })
            .catch(e => {
              r.error = e;
              return r;
            });

      if (cancelToken) {
        this.abortControllers.delete(cancelToken);
      }

      if (!response.ok) throw data;
      return data;
    });
  };
}

/**
 * @title Web Services API
 * @version 1.2.451-b529-02d5dc1
 * @externalDocs /swagger-ui-json
 * @contact Web-Service Team <oebbticketshop-externalapi-pv@oebb.at>
 *
 * ÖBB Webservices API
 */
export class Api<SecurityDataType extends unknown> extends HttpClient<SecurityDataType> {
  api = {
    /**
     * No description
     *
     * @tags Authentication
     * @name AuthControllerLogin
     * @request POST:/api/v1/auth/login
     */
    authControllerLogin: (data: LoginRequest, params: RequestParams = {}) =>
      this.request<LoginResponse, void>({
        path: `/api/v1/auth/login`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Authentication
     * @name AuthControllerRefresh
     * @request POST:/api/v1/auth/refresh
     */
    authControllerRefresh: (data: RefreshRequest, params: RequestParams = {}) =>
      this.request<RefreshResponse, void>({
        path: `/api/v1/auth/refresh`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Booking
     * @name BookingCtrlV2GetBooking
     * @request GET:/api/v2/booking
     */
    bookingCtrlV2GetBooking: (query: { bookingId: string; bookingCode: string }, params: RequestParams = {}) =>
      this.request<GetBookingV2Response, void>({
        path: `/api/v2/booking`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Booking
     * @name BookingCtrlV4Prebook
     * @request POST:/api/v4/booking/prebook
     */
    bookingCtrlV4Prebook: (data: PrebookV4Request, params: RequestParams = {}) =>
      this.request<PrebookV4Response, void>({
        path: `/api/v4/booking/prebook`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Booking
     * @name BookingCtrlV4Finalize
     * @request POST:/api/v4/booking/finalize
     */
    bookingCtrlV4Finalize: (data: FinalizeV4Request, params: RequestParams = {}) =>
      this.request<FinalizeV4Response, void>({
        path: `/api/v4/booking/finalize`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Offer
     * @name OfferV1ControllerShop
     * @request GET:/api/v1/offer/shop
     */
    offerV1ControllerShop: (params: RequestParams = {}) =>
      this.request<ShopResponse[], void>({
        path: `/api/v1/offer/shop`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Offer
     * @name OfferV3ControllerConnectionV2
     * @request POST:/api/v3/offer/getconnection
     */
    offerV3ControllerConnectionV2: (data: ConnectionV3Request, params: RequestParams = {}) =>
      this.request<ConnectionV3Response, void>({
        path: `/api/v3/offer/getconnection`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Offer
     * @name OfferV6ControllerCombinedOffer
     * @request POST:/api/v6/offer/combinedoffer
     */
    offerV6ControllerCombinedOffer: (data: CombinedOfferV6Request, params: RequestParams = {}) =>
      this.request<CombinedOfferV6ResponseFTO[], void>({
        path: `/api/v6/offer/combinedoffer`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Cancel and Cancel Conditions
     * @name CancelV3ControllerCancel
     * @request POST:/api/v3/booking/cancel
     */
    cancelV3ControllerCancel: (data: CancelV3Request, params: RequestParams = {}) =>
      this.request<CancelV3Response, void>({
        path: `/api/v3/booking/cancel`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Cancel and Cancel Conditions
     * @name CancelV4ControllerCancelCond
     * @request POST:/api/v4/booking/cancelcond
     */
    cancelV4ControllerCancelCond: (data: CancelConditionV4Request, params: RequestParams = {}) =>
      this.request<CancelConditionV4Response, void>({
        path: `/api/v4/booking/cancelcond`,
        method: 'POST',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Cards
     * @name CardsV1ControllerGetCards
     * @request GET:/api/v1/cards/{card_number}
     */
    cardsV1ControllerGetCards: (cardNumber: string, query?: { birthDate?: string; zipCode?: string; email?: string }, params: RequestParams = {}) =>
      this.request<CardsV1Response, void>({
        path: `/api/v1/cards/${cardNumber}`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Cards
     * @name CardsV1ControllerGetCardsBlacklist
     * @request GET:/api/v1/cards/validate/blacklist
     */
    cardsV1ControllerGetCardsBlacklist: (params: RequestParams = {}) =>
      this.request<CardsBlacklistResponse, void>({
        path: `/api/v1/cards/validate/blacklist`,
        method: 'GET',
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Ticket and Tax Certificates
     * @name AcquireTicketV2ControllerAcquireTicket
     * @request GET:/api/v2/fulfillment/acquireticket
     */
    acquireTicketV2ControllerAcquireTicket: (
      query: { bookingId: string; bookingCode: string; outputType: 'PDF' | 'LINK'; language?: 'en' | 'de' | 'it' | 'PDF' },
      params: RequestParams = {},
    ) =>
      this.request<AcquireTicketV1Response, void>({
        path: `/api/v2/fulfillment/acquireticket`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Ticket and Tax Certificates
     * @name TaxCertificateControllerV2GetTaxCertificate
     * @request GET:/api/v2/fulfillment/taxcertificate
     */
    taxCertificateControllerV2GetTaxCertificate: (query: { bookingCode: string; bookingId: string }, params: RequestParams = {}) =>
      this.request<TaxCertificateV2Response, void>({
        path: `/api/v2/fulfillment/taxcertificate`,
        method: 'GET',
        query: query,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Master Data
     * @name MasterDataCtrlV1ReductionCardsV2
     * @request GET:/api/v1/masterdata/reductioncards
     */
    masterDataCtrlV1ReductionCardsV2: (data: ReductionCardsV1Request, params: RequestParams = {}) =>
      this.request<ReductionCardsV1Response, void>({
        path: `/api/v1/masterdata/reductioncards`,
        method: 'GET',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Master Data
     * @name MasterDataCtrlV1GetStationList
     * @request GET:/api/v1/masterdata/getstationlist
     */
    masterDataCtrlV1GetStationList: (data: GetStationListV1Request, params: RequestParams = {}) =>
      this.request<GetStationListV1Response[], void>({
        path: `/api/v1/masterdata/getstationlist`,
        method: 'GET',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Management
     * @name ManagementControllerHealth
     * @request ALL:/api/mgmt/health
     */
    managementControllerHealth: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/mgmt/health`,
        method: 'ALL',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Management
     * @name ManagementControllerAlive
     * @request ALL:/api/mgmt/alive
     */
    managementControllerAlive: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/mgmt/alive`,
        method: 'ALL',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Management
     * @name ManagementControllerMetrics
     * @request GET:/api/mgmt/metrics
     */
    managementControllerMetrics: (params: RequestParams = {}) =>
      this.request<void, any>({
        path: `/api/mgmt/metrics`,
        method: 'GET',
        ...params,
      }),

    /**
     * No description
     *
     * @tags Management
     * @name ConfigManagementControllerGetConfig
     * @request GET:/api/mgmt/config
     */
    configManagementControllerGetConfig: (data: ConfigGetV1Request, params: RequestParams = {}) =>
      this.request<ConfigGetV1Response, any>({
        path: `/api/mgmt/config`,
        method: 'GET',
        body: data,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
}
